export default __webpack_public_path__ + "static/media/success.49de3ddd.svg";